export const onboardingVoiceCallAuditStrings = {
  aiReviewTitle: "Auditoría IA — voz onboarding",
  aiReviewSubtitle:
    "Evaluaciones DeepSeek de llamadas del agente de voz (transcripciones en flujo de onboarding).",
  adminOnly: "Solo administrador CRM.",
  monthLabel: "Mes",
  search: "Actualizar",
  onlyWithoutAi: "Solo sin análisis IA",
  excludeVoicemail: "Ocultar buzón de voz",
  excludeWithoutTranscript: "Ocultar sin transcripción",
  noTranscriptChip: "Sin transcripción",
  paginationRange: "Mostrando {from}–{to} de {total}",
  paginationRowsPerPage: "Filas",
  backfillButton: "Analizar pendientes del mes",
  backfillConfirmTitle: "Analizar llamadas pendientes",
  backfillConfirmBody:
    "Se ejecutará análisis IA para transcripciones del mes seleccionado (lote limitado). Puede consumir créditos DeepSeek.",
  backfillConfirmAction: "Ejecutar",
  backfillCancel: "Cancelar",
  backfillResult: "Procesadas: {processed} · Omitidas: {skipped} · Fallidas: {failed}",
  flowColumn: "Flujo / lead",
  phoneColumn: "Teléfono",
  dateColumn: "Transcripción",
  interestColumn: "Interés",
  rubricColumn: "Rúbrica",
  aiStatusColumn: "Estado IA",
  actionsColumn: "Acciones",
  viewAi: "Ver IA",
  runAiAnalysis: "Analizar con IA",
  aiStatusNone: "Sin análisis",
  aiStatusPending: "En proceso",
  aiStatusCompleted: "Completado",
  aiStatusFailed: "Fallido",
  voicemailChip: "Buzón",
  kpiDateBasis: "Métricas según fecha de transcripción",
  kpiTotalCalls: "Llamadas en vivo (mes)",
  kpiAiCompletedPct: "IA completada",
  kpiAvgInterest: "Interés promedio",
  kpiTopFailedRubric: "Rúbrica más fallida",
  kpiSectionTitle: "Auditoría voz onboarding (IA)",
  ceoKpiSection: "KPI Voz onboarding (IA)",
  close: "Cerrar",
  noData: "Sin datos para el mes seleccionado.",
  callsCount: "flujo",
}
